import { Link } from 'react-router-dom'
import { CATEGORIES, formatDate } from '@/data/blog'
import type { Post } from '@/data/blog'

function PostCard({ post }: { post: Post }) {
  const cat = CATEGORIES.find(c => c.slug === post.category)
  return (
    <article className="card flex flex-col overflow-hidden transition-shadow hover:shadow-lift">
      <img
        src={post.image.replace('w=1200', 'w=600')}
        alt={post.imageAlt}
        width={600}
        height={400}
        loading="lazy"
        className="aspect-[3/2] w-full object-cover"
      />
      <div className="flex flex-1 flex-col p-5">
        <p className="text-xs font-bold uppercase tracking-wide text-blueprint-600">
          <Link to={`/blog/category/${post.category}`} className="no-underline hover:underline">
            {cat?.name}
          </Link>
        </p>
        <h2 className="mt-2 text-xl">
          <Link to={`/blog/${post.slug}`} className="text-ink no-underline hover:underline">
            {post.title}
          </Link>
        </h2>
        <p className="mt-2 flex-1 text-steel-600">{post.excerpt}</p>
        <p className="mt-4 text-xs text-steel-500">
          {formatDate(post.datePublished)} &middot; {post.readMinutes} min read
        </p>
      </div>
    </article>
  )
}

export default PostCard
